import axios from 'axios'

const ViolationService = {
  async getList (params = {}) {
    return axios.get('admin/violations', { params })
  },

  async show (id) {
    return axios.get(`admin/violations/${id}`)
  },

  async store (data) {
    return axios.post('admin/violations', data)
  },

  async update (id, data) {
    if (data instanceof FormData) {
      data.append('_method', 'PUT')
      return axios.post(`admin/violations/${id}`, data)
    }

    return axios.put(`admin/violations/${id}`, data)
  },

  async destroy (id) {
    return axios.delete(`admin/violations/${id}`)
  },

  async updateStatus (id, data) {
    return axios.patch(`admin/violations/${id}/status`, data)
  },

  async getEvidence (filename) {
    return axios.get(`shared/violations/evidence/${encodeURIComponent(filename)}`, {
      responseType: 'blob'
    })
  }
}

export default ViolationService
